
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import QuantityInput from './QuantityInput';

interface CustomProductFormProps {
  productName: string;
  productPrice: string;
  quantity: string;
  setProductName: (value: string) => void;
  setProductPrice: (value: string) => void;
  setQuantity: (value: string) => void;
  onAddProduct: () => void;
  onCancel: () => void;
}

const CustomProductForm = ({
  productName,
  productPrice,
  quantity,
  setProductName,
  setProductPrice,
  setQuantity,
  onAddProduct,
  onCancel
}: CustomProductFormProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="productName">Nom du produit</Label>
        <Input
          id="productName"
          placeholder="Nom du produit"
          value={productName}
          onChange={(e) => setProductName(e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="productPrice">Prix unitaire (DZD)</Label>
        <Input
          id="productPrice"
          type="number"
          placeholder="0.00"
          min="0"
          value={productPrice}
          onChange={(e) => setProductPrice(e.target.value)}
        />
      </div>
      <QuantityInput 
        quantity={quantity} 
        setQuantity={setQuantity} 
      />
      <div className="flex gap-2 mt-4">
        <Button 
          variant="outline" 
          className="w-full"
          onClick={onCancel}
        >
          <X className="mr-2 h-4 w-4" />
          Annuler
        </Button>
        <Button 
          className="w-full bg-indigo-500 hover:bg-indigo-600 text-white rounded-md"
          onClick={onAddProduct}
        >
          Ajouter
        </Button>
      </div>
    </>
  );
};

export default CustomProductForm;
